export default {
  widgets: {
    problemCaseCommentPanel: {
      title: 'Заметка',
      submit: 'Отправить',
      addNote: 'Добавить заметку',
    },
  },
};
